const sdk = require ("./QCObjects-SDK");
module.exports = sdk;